import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import store from './store/store'
import NetworkIssue from './views/NetworkIssue.vue'
import { azureAD } from '@/const'
import { capturePageview } from '@/plugins/posthog'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/register',
      name: 'register',
      component: resolve => require([`@/views/Register`], resolve),
      beforeEnter(to, from, next) {
        const loggedIn = localStorage.getItem('user')
        if (loggedIn) {
          next('/')
        }
        next()
      }
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      component: resolve => require([`@/views/SignIn`], resolve),
      beforeEnter(to, from, next) {
        const loggedIn = localStorage.getItem('user')
        if (loggedIn) {
          next('/')
        }
        next()
      }
    },
    {
      path: '/receive-notification',
      name: 'receive-notification',
      component: resolve => require([`@/views/ReceiveNotification`], resolve),
      beforeEnter(to, from, next) {
        // const loggedIn = localStorage.getItem('user')
        // if (loggedIn) {
        //   next('/')
        // }
        next()
      }
    },
    {
      path: '/verify-invitation',
      name: 'verify-invitation',
      component: resolve => require([`@/views/VerifyInvitation`], resolve),
      beforeEnter(to, from, next) {
        next()
      }
    },
    {
      path: '/',
      name: 'home',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: resolve => require([`@/components/layout/layout`], resolve),
      children: [
        {
          path: '/',
          component: resolve => require([`@/views/Home.vue`], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/dashboard/landing',
          component: resolve =>
            require([`@/views/DashboardLanding.vue`], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/care-plus-dashboard',
          component: resolve =>
            require(['@/views/CarePlusDashboard.vue'], resolve),
          meta: {
            requireAuth: true,
            permissions: ['Dashboard.View']
          }
        },
        {
          path: '/dashboard',
          component: resolve => {
            require(['@/views/Dashboard.vue'], resolve)
          },
          meta: {
            requireAuth: true,
            permissions: ['Classic Dashboard.View']
          }
        },
        {
          path: '/patients',
          component: resolve => require([`@/views/Patients.vue`], resolve),
          meta: {
            requireAuth: true,
            permissions: ['Patients.View']
          },
          children: [
            {
              path: '/patients/landing',
              component: resolve =>
                require([`@/views/patients/PatientLandingPage.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.View']
              }
            },
            {
              path: '/patients/monitor',
              component: resolve =>
                require([`@/views/patients/Monitor.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.View']
              }
            },
            {
              path: '/patients/voiding-chart',
              component: resolve =>
                require([`@/views/patients/VoidingChart.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Charts.Void.View']
              }
            },
            {
              path: '/patients/smartz-events-chart',
              component: resolve =>
                require([`@/views/patients/SmartzEventsChart.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Charts.Event.View']
              }
            },
            {
              path: '/patients/pad-fill-profile-chart',
              component: resolve =>
                require([`@/views/patients/PadFillProfileChart.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Charts.FillProfile.View']
              }
            },
            {
              path: '/patients/position-chart',
              component: resolve =>
                require([`@/views/patients/PositionChart.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Charts.BodyPosition.View']
              }
            },
            {
              path: '/patients/physical-activity-chart',
              component: resolve =>
                require([
                  `@/views/patients/PhysicalActivityChart.vue`
                ], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Charts.PhysicalActivity.View']
              }
            },
            {
              path: '/patients/smartz-devices',
              component: resolve =>
                require([`@/views/patients/SmartzDevices.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: []
              }
            },
            {
              path: '/patients/pad-fill-profile-goal',
              component: resolve =>
                require([`@/views/patients/goal/PadFillProfile.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Goals.FillProfile.View']
              }
            },
            {
              path: '/patients/skin-care-goal',
              component: resolve =>
                require([`@/views/patients/goal/SkinCare.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Goals.SkinCare.View']
              }
            },
            {
              path: '/patients/position-goal',
              component: resolve =>
                require([`@/views/patients/goal/Position.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Goals.Position.View']
              }
            },
            {
              path: '/patients/temperature-goal',
              component: resolve =>
                require([`@/views/patients/goal/Temperature.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Goals.Temperature.View']
              }
            },
            {
              path: '/patients/fall-detection-goal',
              component: resolve =>
                require([`@/views/patients/goal/Falls.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Goals.Fall.View']
              }
            },
            {
              path: '/patients/productivity-goal',
              component: resolve =>
                require([`@/views/patients/goal/Productivity.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Goals.SkinCare.View']
              }
            },
            {
              path: '/patients/inco-assessment',
              component: resolve =>
                require([`@/views/patients/IncoAssessment.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Goals.Fall.View']
              }
            },
            {
              path: '/patients/observation-chart',
              component: resolve =>
                require([`@/views/patients/ObservationChart.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Inco-assessment.View']
              }
            }
          ]
        },
        {
          path: '/manage',
          component: resolve => require([`@/views/Manage.vue`], resolve),
          meta: {
            requireAuth: true,
            permissions: ['Organisations.View']
          },
          children: [
            {
              path: '/manage/landing',
              component: resolve =>
                require([`@/views/manage/ManageLanding.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Organisations.View']
              }
            },
            {
              path: '/manage/data-privacy',
              component: resolve =>
                require([`@/views/manage/patients/DataPrivacy.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Organisations.View']
              }
            },
            {
              path: '/manage/organisation-profile',
              component: resolve =>
                require([
                  `@/views/manage/organisation/OrganisationProfile.vue`
                ], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Organisations.View']
              }
            },
            {
              path: '/manage/buildings-rooms',
              component: resolve =>
                require([
                  `@/views/manage/organisation/BuildingsAndRooms.vue`
                ], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Organisations.View']
              }
            },
            {
              path: '/manage/organisation-structure',
              component: resolve =>
                require([
                  `@/views/manage/organisation/OrganisationStructure.vue`
                ], resolve),
              meta: {
                requireAuth: true
                // permissions: ['Manage Module.Organisation.Profile.Save']
              }
            },
            {
              path: '/manage/manufacturers',
              component: resolve =>
                require([
                  `@/views/manage/organisation/Manufacturers.vue`
                ], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manufacturers.View']
              }
            },
            {
              path: '/manage/network-map',
              component: resolve =>
                require([
                  `@/views/manage/organisation/NetworkMap.vue`
                ], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Organisations.Network.View']
              }
            },
            {
              path: '/manage/network-utilisation',
              component: resolve =>
                require([
                  `@/views/manage/organisation/NetworkUtilisation.vue`
                ], resolve),
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/manage/organisation-observation',
              component: resolve =>
                require([
                  `@/views/manage/organisation/Observation.vue`
                ], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Observations.View']
              }
            },
            {
              path: '/manage/organisation-setting',
              component: resolve =>
                require([`@/views/manage/organisation/Setting.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Organisations.View']
              }
            },
            {
              path: '/manage/organisation-reporting',
              component: resolve =>
                require([`@/views/manage/organisation/Reporting.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Reports.View']
              }
            },
            {
              path: '/manage/application-link-key',
              component: resolve =>
                require([
                  `@/views/manage/organisation/ApplicationLinkKey.vue`
                ], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Organisations.Interoperability.View']
              }
            },
            {
              path: '/manage/my-account',
              component: resolve =>
                require([`@/views/manage/MyAccount.vue`], resolve),
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/manage/admin-permissions',
              component: resolve =>
                require([`@/views/manage/admin/AdminPermission.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Organisations.RolesPermission.View']
              }
            },
            // {
            //   path: '/manage/admin-algorithms',
            //   component: resolve =>
            //     require([`@/views/manage/admin/AdminAlgorithms.vue`], resolve),
            //   meta: {
            //     requireAuth: true,
            //     permissions: ['Organisations.Customisation.View']
            //   }
            // },
            // {
            //   path: '/manage/admin-data-privacy',
            //   component: resolve =>
            //     require([`@/views/manage/admin/AdminDataPrivacy.vue`], resolve),
            //   meta: {
            //     requireAuth: true,
            //     permissions: ['Organisations.Customisation.View']
            //   }
            // },
            {
              path: '/manage/admin-customization',
              component: resolve =>
                require([`@/views/manage/admin/Customization.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Organisations.Customisation.View']
              }
            },
            {
              path: '/manage/user-accounts',
              component: resolve =>
                require([`@/views/manage/users/UserAccounts.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Users.View']
              }
            },
            {
              path: '/manage/invite-user',
              component: resolve =>
                require([`@/views/manage/users/InviteUser.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Users.Invite']
              }
            },
            {
              path: '/manage/patient-list',
              component: resolve =>
                require([`@/views/manage/patients/PatientList.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.View']
              }
            },
            {
              path: '/manage/report',
              component: resolve =>
                require([`@/views/manage/report/Report.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Reports.View']
              }
            },
            {
              path: '/manage/report-history',
              component: resolve =>
                require([`@/views/manage/report/ReportHistory.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Reports.View']
              }
            },
            {
              path: '/manage/devices-pods',
              component: resolve =>
                require([`@/views/manage/devices/Location.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Devices.Pod.View']
              }
            },
            {
              path: '/manage/devices-nodes',
              component: resolve =>
                require([`@/views/manage/devices/NodeManagement.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Devices.Node.View']
              }
            }
          ]
        },
        {
          path: '/reports',
          component: resolve => require([`@/views/Reports.vue`], resolve),
          meta: {
            requireAuth: true,
            permissions: ['Reports.View']
          },
          children: [
            {
              path: '/reports/generate',
              component: resolve =>
                require([`@/views/reports/Generate.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Reports.View']
              }
            },
            {
              path: '/reports/history',
              component: resolve =>
                require([`@/views/reports/History.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Reports.View']
              }
            }
          ]
        },
        {
          path: '/404',
          name: '404',
          component: resolve => require([`@/views/NotFound.vue`], resolve)
        }
      ],
      beforeEnter(routeTo, routeFrom, next) {
        let tokenInfo = localStorage.getItem('tokenInfo')
          ? JSON.parse(localStorage.getItem('tokenInfo'))
          : null

        // if user havn't sign in, cannot access these page
        if (!tokenInfo) {
          clearLocalStorage()
          next('/sign-in')
          return
        }

        // If the user is in the login process and has not verified the mfa code (multi factor is enabled), access to the dashboard is prohibited
        if (
          !localStorage.getItem('currentPolicy') ||
          localStorage.getItem('currentPolicy') === azureAD.policy
        ) {
          if (
            !store.getters[`user/haveVerifyMfa`] &&
            store.getters[`user/isMultiFactorEnabled`]
          ) {
            clearLocalStorage()
            next('/sign-in')
            return
          }
        }

        if (routeFrom.path === '/sign-in' || routeFrom.path === '/register') {
          getCustomTheme(next)
          return
        } else {
          getBasicInfo(next)
          return
        }
      },
      meta: { requiresAuth: true }
    },
    {
      path: '*',
      redirect: { name: '404' }
    },
    {
      path: '/network-issue',
      name: 'network-issue',
      component: NetworkIssue
    }
  ]
})

router.beforeEach((routeTo, routeFrom, next) => {
  NProgress.start()
  const loggedIn = localStorage.getItem('user')
  // If user don't login, site will directly jump to the sign in page
  if (routeTo.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/sign-in')
  }

  // Whether the current user has permission to view the page
  if (
    routeTo.meta &&
    routeTo.meta.permissions &&
    routeTo.meta.permissions.length
  ) {
    let flag = false
    let permissions = JSON.parse(localStorage.getItem('permissions'))
    permissions.forEach(permission => {
      if (routeTo.meta.permissions.indexOf(permission) > -1) {
        flag = true
      }
    })
    if (!flag) {
      next('/404')
    }
  }

  next()
})

router.afterEach(to => {
  NProgress.done()
  capturePageview(window.location.origin + to.fullPath)
})

const getCustomTheme = function(next) {
  store
    .dispatch('customization/getCustomTheme')
    .then(response => {
      if (response instanceof Error) {
        next({ name: 'network-issue' })
      } else {
        next()
      }
    })
    .catch(() => next({ name: 'network-issue' }))
}

const getBasicInfo = function(next) {
  store
    .dispatch('customization/getCustomTheme')
    .then(response => {
      if (response instanceof Error) {
        next({ name: 'network-issue' })
      } else {
        store.dispatch('patient/fetchPatients').then(response => {
          if (response instanceof Error) {
            next({ name: 'network-issue' })
          } else {
            store.dispatch('filter/getUserFilter').then(() => {
              next()
            })
          }
        })
      }
    })
    .catch(() => next({ name: 'network-issue' }))
}

const clearLocalStorage = () => {
  localStorage.removeItem('user')
  localStorage.removeItem('tokenInfo')
  localStorage.removeItem('permissions')
  localStorage.removeItem('currentPolicy')
  localStorage.removeItem('codeVerifier')
  store.dispatch('region/clearRegion')
}

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
export default router
